import FileImageIcon from '../assets/file-image.svg?react'
import FilePDFIcon from '../assets/file-pdf.svg?react'
import FileIcon from '../assets/file.svg?react'

export const getFileIcon = (contentType: string) => {
  if (contentType === 'application/pdf') return FilePDFIcon
  if (contentType.startsWith('image/')) return FileImageIcon
  return FileIcon
}
